// src/components/Steps.tsx

import { Stethoscope, FileText, Leaf, Package } from 'lucide-react'

const steps = [
  {
    id: 1,
    title: 'Consulta médica descomplicada',
    description:
      'Agende de forma simples com médicos parceiros da Cannect. Eles avaliam seu caso com atenção e indicam o melhor caminho para iniciar seu tratamento com cannabis medicinal, com segurança e acolhimento.',
    icon: <Stethoscope className="h-10 w-10 text-primary-700" />
  },
  {
    id: 2,
    title: 'Autorização na Anvisa sem burocracia',
    description:
      'A Cannect cuida de toda a parte burocrática para você. Preparamos a documentação, fazemos a solicitação e acompanhamos o processo de autorização junto à Anvisa com agilidade, clareza e total suporte.',
    icon: <FileText className="h-10 w-10 text-primary-700" />
  },
  {
    id: 3,
    title: 'Importação segura e assistida',
    description:
      'Após a liberação, cuidamos de todo o processo de importação do medicamento. Da compra até a chegada no Brasil, garantimos segurança, rastreabilidade e atendimento próximo durante cada etapa.',
    icon: <Leaf className="h-10 w-10 text-primary-700" />
  },
  {
    id: 4,
    title: 'Entrega com cuidado no seu endereço',
    description:
      'Seu medicamento chega em casa com total comodidade. Nossa equipe acompanha tudo de perto para que você receba seu tratamento com segurança, tranquilidade e o suporte que você merece.',
    icon: <Package className="h-10 w-10 text-primary-700" />
  }
]

export default function Steps() {
  return (
    <section className="flex w-full flex-row gap-6 md:flex-wrap lg:flex-nowrap">
      {steps.map((step) => (
        <div
          key={step.id}
          className="flex min-h-[338px] w-[280px] flex-shrink-0 flex-col gap-4 rounded-lg bg-white pb-6 pl-4 pr-4 pt-6 opacity-100 shadow-md md:w-full lg:w-[273px]">
          {step.icon}
          <h3 className="break-words font-poppins text-lg font-semibold leading-[140%] text-gray-800">
            <span className="text-primary-700">Passo {step.id}. </span>
            {step.title}
          </h3>
          <p className="break-words overflow-wrap-anywhere font-poppins text-sm font-normal leading-[140%] text-gray-600">
            {step.description}
          </p>
        </div>
      ))}
    </section>
  )
}
